import { render, staticRenderFns } from "./Business-log.vue?vue&type=template&id=22484565"
import script from "./Business-log.vue?vue&type=script&lang=js"
export * from "./Business-log.vue?vue&type=script&lang=js"
import style0 from "./Business-log.vue?vue&type=style&index=0&id=22484565&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports